import styled from "styled-components";
import theme from "../../Styles/theme";


export const ContainerFixed = styled.div`
position: fixed;
  z-index:2;
  height:100vh;
  background-color:red;




`;

export const Container = styled.div`
  /* background-color: ${theme.colors.light};
 

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  padding: 10vh 2vw; */
  /* width:100%; */
  background: ${theme.colors.light};
  height: 100vh;
  //max-width: 60vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding: 2vw;

  width: max(20vw,150px);

`;

export const Titulo = styled.h1`
  color: ${theme.colors.dark};
  font-size:16px;
  text-align:"center";
`;

export const Header = styled.div`

  display:"flex";
  align-items:"center";
  justify-content:"center";
  flex-direction:"column";
  background-color:"red";
`;

export const Navigator = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FooterSpan = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  font-size: 16px;
`;


export const ButtonMenu = styled.button`

  position:fixed;
  top:0;
  margin-top:1vh;
  margin-left:2vw;

`;


export const XHeader = styled.div`

  display:flex;
  width:100%;
  align-items: right;
  justify-content: flex-end;

`;